export const SET_DISPLAY_DATA = 'SET_DISPLAY_DATA';
export const STASH_TARGETING_INFO_CHANGES = 'STASH_TARGETING_INFO_CHANGES';
export const SET_SAVING_STATUS = 'SET_SAVING_STATUS';
export const CLOSE_DATA_FILLING_HINT = 'CLOSE_DATA_FILLING_HINT';
export const SET_USER_SEGMENTS = 'SET_USER_SEGMENTS';
export const CLEAR_TARGETING_INFO = 'CLEAR_TARGETING_INFO';
